module.exports = __webpack_public_path__ + "static/media/Paratiisi-BG-Pattern-300x140.7e13d642.png";